module.exports = __webpack_public_path__ + "img/04-thumb.83c63b8e.jpg";